import _ from 'lodash'
import React, { useState } from 'react'
import {
  PreviewSkeletonType
  // SkeletonConfigType
} from 'src/lib/types/uiPreview'
import Pill from './Pill'

interface LoadingPaymentMethodProps {
  length: number
  skeleton: PreviewSkeletonType
}

const LoadingPaymentMethod: React.FC<LoadingPaymentMethodProps> = ({ length, skeleton }) => {
  return (
    <>
      {_.times(length, (index: number) => {
        return (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '1rem',
              width: '100%',
              gap: 16,
              border: `1px solid #f0f0f0`,
              borderRadius: '16px 16px 28px 28px'
            }}
          >
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  gap: 6
                }}
              >
                <Pill height={1} width={1} />
                <Pill height={1} width={6} />
              </div>
            </div>
            {skeleton?.config?.map((item: any, index: number) => {
              return (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: skeleton.layout,
                    alignItems: 'start',
                    padding: '1rem',
                    width: '100%',
                    border: `1px solid `,
                    borderColor: '#F0F0F0',
                    borderRadius: '16px',
                    gap: '8px'
                  }}
                  key={index}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: skeleton?.config?.[index].layout,
                      gap: 6,
                      justifyContent: skeleton?.config?.[index]?.justify
                    }}
                  >
                    {skeleton?.config?.[index]?.config?.map((item: any, index: number) => {
                      return <Pill height={item?.height} width={item?.width} key={index} />
                    })}
                  </div>

                  {skeleton?.config?.map((item: any, index: number) => {
                    return <Pill height={item?.height} width={item?.width} key={index} />
                  })}
                </div>
              )
            })}
          </div>
        )
      })}
    </>
  )
}

export default LoadingPaymentMethod
